import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AcceuilCardComponent } from './acceuil-card/acceuil-card.component';
import { StatistiqueModerationCardComponent } from './statistique-moderation-card/statistique-moderation-card.component';
import { StatistiqueUserCardComponent } from './statistique-user-card/statistique-user-card.component';
import { StatistiqueTimelineCardComponent } from './statistique-timeline-card/statistique-timeline-card.component';
import {CardModule} from 'primeng/card';
import {PanelModule} from 'primeng/panel';
import {TableModule} from 'primeng/table';
import {ChartModule} from 'primeng/chart';
import {ProgressBarModule} from 'primeng/progressbar';



@NgModule({
  declarations: [AcceuilCardComponent, StatistiqueModerationCardComponent, StatistiqueUserCardComponent, StatistiqueTimelineCardComponent],
  exports: [
    AcceuilCardComponent,
    StatistiqueTimelineCardComponent,
    StatistiqueUserCardComponent,
    StatistiqueModerationCardComponent
  ],
  imports: [
    CommonModule,
    CardModule,
    PanelModule,
    TableModule,
    ChartModule,
    ProgressBarModule
  ]
})
export class AccueilModule { }
